<template>
  <!--
    优惠券到期主动气泡
    外壳：AgentTipFrame；样式：theme.entryTipStyle
    文案：entryTexts（payAssistant 配置；muteBtn/muteToast 与 BrowseSilenceTip 共用）
  -->
  <agent-tip-frame
    :tip-style="tipStyle"
    :assistant-name="assistantName"
    @close="$emit('close')"
  >
    <template #message>{{ message }}</template>
    <template #actions>
      <button type="button" class="btn-gotit" @click.stop="handleViewDetail">
        {{ viewDetailBtn }}
      </button>
      <button type="button" class="btn-quiet" @click.stop="$emit('mute')">
        {{ muteBtn }}
      </button>
    </template>
  </agent-tip-frame>
</template>

<script>
import AgentTipFrame from './AgentTipFrame.vue';

/**
 * CouponExpireTip
 * 事件：
 * - viewDetail：优惠查询
 * - mute：暂时不需要（24h 静音）
 * - close：折叠收起（不写静音）
 */
export default {
  name: 'CouponExpireTip',
  components: { AgentTipFrame },
  props: {
    tipStyle: {
      type: Object,
      default: () => ({})
    },
    assistantName: {
      type: String,
      default: ''
    },
    coupon: {
      type: Object,
      default: () => ({})
    },
    message: {
      type: String,
      default: ''
    },
    muteBtn: {
      type: String,
      default: ''
    },
    viewDetailBtn: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleViewDetail() {
      this.$emit('viewDetail');
    }
  }
};
</script>
